export enum EntityType {
  DATASET = 'Dataset',
  AI_SYSTEM = 'AISystem',
  RISK_REGISTER = 'RiskRegister',
  INCIDENT = 'Incident',
  VULNERABILITY = 'Vulnerability',
  AI_SYSTEM_TEVV = 'AISystem-tevv',
  AI_SYSTEM_FAILURE = 'AISystem-failure',
}

export enum HistoryActionType {
  CREATED = 'created',
  UPDATED = 'updated',
  LINKED = 'linked',
  UNLINKED = 'unlinked',
  DELETED = 'deleted',
  ARCHIVED = 'archived',
  RESTORED = 'restored',
}
